export type Mood = {
  id: string;
  name: string;
};

export const moods: Mood[] = [
  {
    id: 'happy',
    name: 'Happy',
  },
  {
    id: 'silly',
    name: 'Silly',
  },
  {
    id: 'restful',
    name: 'Restful',
  },
  {
    id: 'anxious',
    name: 'Anxious',
  },
  {
    id: 'tired',
    name: 'Tired',
  },
  {
    id: 'thoughtful',
    name: 'Thoughtful',
  },
  {
    id: 'sad',
    name: 'Sad',
  },
  {
    id: 'frustrated',
    name: 'Frustrated',
  },
  {
    id: 'bored',
    name: 'Bored',
  },
];
